import { getPrefix } from "./getPrefix";

export const getPrintFieldNames = (t: any, code: string) => {
  switch (code) {
    case "PREPCO":
      return t(`p.cost`);
    case "TAX":
      return t(`p.tax`);
    default:
      return t(`c.${getPrefix(code)}`);
  }
};
